import React, { useMemo } from "react";
import useUI from "hooks/ui.hook";
import PropTypes from "prop-types";
import { useMenu } from "../../../router_context";
import styles from "../../../Basic/Assets/scss/modalInformations.module.scss";
import { Tag } from "lib/components";
import { findSubscriptionNameForDate } from "../../../helpers/operations";

const colors = ["#8c66dc", "#dc6681", "#00bfb2", "#DC965A", "#81171B"];
const colorUnite = "#123865";

const fixe = ["assiette de fromage", "faisselle"];


const ModalInformations = ({ reservation, page }) => {
    const [ui] = useUI();
    const [ctx] = useMenu();

    const currentUser =  ui.user;
    const templateSubscription = ui.establishment.templateSubscription;
    const subscription = findSubscriptionNameForDate(ctx.isMenuV2, currentUser, ctx?.selectedDate, ctx?.modalInfos?.repas);
    const dataDay = ctx?.data[ctx?.selectedDate];

    const selectedFormula = useMemo(() => {
        if (ctx.modalInfos.repas === "Déjeuner") {
            let count = 0;
            if (reservation[page]) {

                if (reservation[page]["entrée"]) count++;
                if (reservation[page]["plat"]) count++;
                if (reservation[page]["dessert"]) count++;
            }

            if (count === 2) return "DUO";
            if (count === 3) return "TRIO";

            return null;
        }
        if (ctx.modalInfos.repas === "Dîner") {
            let count = 0;
            if (reservation[page]) {

                if (reservation[page]["entrée"]) count++;
                if (reservation[page]["plat"]) count++;
                if (reservation[page]["dessert"]) count++;
            }

            if (count >= 2) return "DUO";
            return null;
        }
        return null;
    }, [dataDay, reservation, ctx, page]);

    return (
        <div className={styles.container}>
            {/* <div className={styles.content}>
                <div className={styles.title}> {currentUser?.surname} {currentUser?.name} {page > 0 ? `(Invité ${page})` : ""}</div>
            </div>
            {page === 0 && templateSubscription ?
                <div className={styles.content}>
                    <div className={styles.title}> Abonnement : </div>
                    {subscription ?
                        subscription === "1/2p Duo" ?
                            <div>
                                <Tag className={styles.tag} style={{ backgroundColor: colors[0] }}><div>Demi Pension</div></Tag>
                                <Tag className={styles.tag} style={{ backgroundColor: colors[1] }}><div>DUO</div></Tag>
                            </div>
                            :
                            subscription === "1/2p Trio" ?
                                <div>
                                    <Tag className={styles.tag} style={{ backgroundColor: colors[0] }}><div>Demi Pension</div></Tag>
                                    <Tag className={styles.tag} style={{ backgroundColor: colors[2] }}><div>TRIO</div></Tag>
                                </div>
                                : null
                        :
                        <Tag className={styles.tag} style={{ backgroundColor: colorUnite }}><div>Unité</div></Tag>
                    }
                </div>
                : null} */}

            <div className={styles.content}>
                <div className={styles.title}> Formule : </div>
                {selectedFormula ? <div>
                    <Tag className={styles.tag} style={{ backgroundColor: colors[selectedFormula === "DUO" ? 1 : 2] }}><div>{selectedFormula}</div></Tag>
                </div> : null}
                {/* {
                    template[ctx.modalInfos.repas].categories.map((_categ, indx) => (
                        reservation[page] && reservation[page][_categ] && _categ !== "garniture" ? <div key={indx}>{_categ} </div> : null
                    ))
                } */}
            </div>
            {reservation[page] && reservation[page]["supplément"] ?
                <div className={styles.content}>
                    <div className={styles.title}> Supplément <span className={styles.priceUp}>(€)</span> : </div>
                    {
                        <div>{fixe.includes(reservation[page]["supplément"]) ? reservation[page]["supplément"] : "dessert"} </div>
                    }
                </div>
                : null
            }

            {templateSubscription && subscription && page === 0 && templateSubscription[subscription].repas[ctx.modalInfos.repas] && subscription.toUpperCase().includes("DUO") && selectedFormula === "TRIO" ?
                <div className={styles.content}>
                    <div className={styles.title}> Surclassement <span className={styles.priceUp}>(€)</span> : </div>
                    <Tag className={styles.tag} style={{ backgroundColor: colors[selectedFormula === "DUO" ? 1 : 2] }}><div>{selectedFormula}</div></Tag>
                </div>
                : null}

            {/* {templateSubscription && subscription ?
                page === 0 ?
                <div className={styles.content}>
                    {subscription && templateSubscription[subscription].repas[ctx.modalInfos.repas] ?
                        <div className={styles.text}> Le {ctx.modalInfos.repas} est compris dans votre abonnement.</div>
                        :
                        <div className={styles.text}> Le {ctx.modalInfos.repas} n&apos;est pas compris dans votre abonnement. </div>
                    }
                </div>
                : <div></div>
                : <div></div>} */}

        </div>
    );
};


ModalInformations.propTypes = {
    reservation: PropTypes.array,
    page: PropTypes.number,
};

export default ModalInformations;
